import {
  contentEnd,
  contentStart,
  customStyle,
  styleEnd,
} from "../../algorithms/styleDirection";
import { useNavigate } from "react-router-dom";
import "./tasksStyle.css";
import moment from "moment";
import "moment/locale/ar";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TaskAttachmentsPopup from "./taskAttachmentsPopup";
import TaskDetailsCard from "./taskDetailsCard";
import Lang from "../../userPreferences/staticWords";
import {
  getAllSubTaskAttachments,
  getAllTaskAttachments,
  getEditDataTaskForm,
} from "../../API/store/actions/tasks";
import DetailsPopup from "./taskDetailsPopup";
import { paths } from "../../paths/paths";
import ModalComponent from "../reusableComponents/modal";
import AddProcedureForm from "./addProcedure/addProcedureForm";
import ReactTooltip from "react-tooltip";
import Pulse from "react-reveal/Pulse";
import Button from "./../sharedComponents/buttons/button";
import { resolver } from "../../API/middlewares/resolveRequests";
import AddTaskAttachments from "./addTaskAttachmentPopup";
import TaskStatus from "./taskStatus/taskStatus";
import EditTaskForm from "./editTask/editTaskForm";
import DeleteProcAlert from "./editProc.js/deleteProc";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import SubTaskDetailsCard from "./subtaskDetailsCard";
import { hex2rgba } from "../../algorithms";
import { editSubTaskData } from "./../../API/store/actions/tasks";
import EditSubTaskForm from "./subTask/editSubTask";

const SubTaskDetails = (props) => {
  const { setProcAdded, procAdded, details } = props;
  const history = useNavigate();
  const changeElementActiveClass = (element) => {
    let elements = document.querySelectorAll(".itemNav");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("iconsBackgroundActiveClass");
      elements[i].children[0].classList.remove("iconsActiveClass");
    }
    element.currentTarget.children[0].classList.add("iconsActiveClass");
    element.currentTarget.classList.add("iconsBackgroundActiveClass");
  };
  const [show, setshow] = useState({ id: null, display: false });
  const [subTaskId, setSubTaskId] = useState(null);

  const userToken = useSelector((state) => state.login.userToken);

  const [showTaskAttachmentsPopup, setshowTaskAttachmentsPopup] = useState(
    false
  );
  const [taskAttachmentsContent, settaskAttachmentsContent] = useState([]);
  const community = useSelector((state) => state.community.communityId);

  const onshowTaskAttachmentsPopup = () => {
    setshowTaskAttachmentsPopup(true);
  };

  const renderTaskAttachmentsModal = (taskAttachmentsContent) => {
    return (
      <TaskAttachmentsPopup
        isActivity={true}
        name={details.name}
        content={taskAttachmentsContent}
        show={showTaskAttachmentsPopup}
        onHide={() => setshowTaskAttachmentsPopup(false)}
      />
    );
  };

  const dispatch = useDispatch();
  const TaskAttachments = useSelector(
    (state) => state.tasks.getAllSubTaskAttachments
  );

  const [visibleProc, setVisibleProc] = useState(false);

  useEffect(() => {
    dispatch(getAllSubTaskAttachments(details.id, 1, 10000, userToken));
    if (Lang.getLanguage() === "ar") moment.locale("ar");
    else moment.locale("en");
  }, []);

  const [data, setData] = useState(null);
  const [visibleStatus, setVisibleStatus] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const communityId = useSelector((state) => state.community.communityId?.id);
  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);
  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = () => {
    return (
      <AddTaskAttachments
        userToken={userToken}
        procAdded={procAdded}
        setProcAdded={setProcAdded}
        subTaskId={subTaskId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };
  useEffect(() => {
    if (data) setVisibleEdit(true);
  }, [data]);

  document.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menuDetails")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  if (details) {
    return (
      <>
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              subTaskId={subTaskId}
              setVisible={setDeleteModalVisible}
              content={"هل تريد حذف الإجراء الفرعي وملحقاته ؟"}
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
        <ModalComponent
          body={
            <EditSubTaskForm
              subTaskId={subTaskId}
              setVisible={setVisibleEdit}
              data={data?.data}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              userToken={userToken}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEdit}
          modalVisible={visibleEdit}
          size={"xl"}
          title={"تعديل الإجراء الفرعي"}
        />
        <ModalComponent
          body={
            <AddProcedureForm
              subTaskId={details.id}
              taskId={taskId}
              setVisible={setVisibleProc}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              userToken={userToken}
            />
          }
          hasImage={
            <div
              style={{
                backgroundColor: "#1A73E8",
                height: 26,
                width: 26,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  background:
                    "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                  opacity: 1,
                  filter: "opacity(1) brightness(20)",
                }}
                className="any"
              ></div>
            </div>
          }
          setModalVisible={setVisibleProc}
          modalVisible={visibleProc}
          size={"xl"}
          title={Lang.addProcedure}
        />
        {/* Task Details Title and Filter Card */}
        <div
          className={`d-flex flex-column col-11 col-xl-12 ${customStyle(
            "TitleCard"
          )}`}
        >
          {/* back to home Link */}
          <div
            className="d-flex align-items-center px-4 py-2"
            onClick={() => {
              history(-1);
            }}
          >
            <div className="px-2">
              <div
                style={{
                  backgroundColor: "white",
                  height: 20,
                  width: 18,
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center my-1"
              >
                <div
                  style={{
                    width: 18,
                    height: 20,
                    background: "url('/assets/images/icons/fi-br-layers.png')",
                    opacity: 1,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
              </div>
            </div>
            <p
              className={`my-0 ${styleEnd("m", 3)} hoverLinks`}
              style={{ lineHeight: 1.5, fontSize: 14 }}
            >
              {"رجوع إلى تفاصيل الإجراء"}
            </p>
            {/* </Link> */}
          </div>

          {/* name and icons*/}
          <div className="d-flex flex-md-row  align-items-start px-4 py-1">
            <h5
              className={`my-0 ${styleEnd("m", 3)}`}
              style={{ lineHeight: 1.5, textAlign: "justify" }}
            >
              {details.name}
            </h5>

            <div className="d-flex align-items-center col justify-content-end my-2 my-md-0">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  border: "1px solid rgba(199, 199, 201, 1)",
                  borderRadius: 4,
                  height: 32,
                  width: 32,
                  cursor: "pointer",
                }}
                onClick={() => {
                  onshowTaskAttachmentsPopup();
                  if (TaskAttachments?.data)
                    settaskAttachmentsContent(TaskAttachments);
                  else settaskAttachmentsContent(null);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12.188"
                  viewBox="0 0 16 12.188"
                >
                  <path
                    id="folder_1_"
                    data-name="folder (1)"
                    d="M15.869,67.188a1.092,1.092,0,0,0-.963-.575H12.813v-2.5a1.251,1.251,0,0,0-1.25-1.25H5.938v-.625a1.251,1.251,0,0,0-1.25-1.25H1.25A1.251,1.251,0,0,0,0,62.237V72.706H0a.468.468,0,0,0,.469.469H12.344a.469.469,0,0,0,.391-.21l3.084-4.657A1.092,1.092,0,0,0,15.869,67.188ZM1.25,61.925H4.688A.313.313,0,0,1,5,62.237v1.094a.469.469,0,0,0,.469.469h6.094a.313.313,0,0,1,.313.313v2.5h-.938V65.206a.469.469,0,0,0-.469-.469H2.344a.469.469,0,0,0-.469.469V69.57l-.938,1.5V62.237a.313.313,0,0,1,.313-.313Zm2.732,4.688a.469.469,0,0,0-.4.22l-.772,1.236V65.675H10v.938Zm11.055,1.179-2.944,4.446H1.314l1.412-2.261a.466.466,0,0,0,.031-.049L4.242,67.55H14.906a.156.156,0,0,1,.131.242Z"
                    transform="translate(0 -60.987)"
                    fill="#12aac4"
                  />
                </svg>
              </div>

              {/* ellipses start */}
              {show.id == details.id ? (
                <div className="d-flex justify-content-end align-items-start btn-group">
                  <>
                    <div
                      style={{ display: show.display ? "block" : "none" }}
                      className={`${customStyle("arrow-horizontalDetails")} ${
                        show.display ? "show" : ""
                      }`}
                    ></div>
                    <ul
                      className={`${customStyle("dropdown-menuDetails")} ${
                        show.display ? "show" : ""
                      }`}
                      style={{
                        display: show.display ? "block" : "none",
                      }}
                    >
                      {community?.adminTask && (
                        <>
                          <li
                            style={{ cursor: "pointer" }}
                            id={details.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              resolver(
                                editSubTaskData,
                                setData,
                                currentId,
                                communityId,
                                userToken
                              );
                              setSubTaskId(currentId);
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              تعديل الإجراء الفرعي
                            </span>
                          </li>
                          <li
                            style={{ cursor: "pointer" }}
                            id={details.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              setSubTaskId(currentId);
                              onShowAttachments();
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              اضافة مرفقات
                            </span>
                          </li>
                        </>
                      )}
                      <li
                        style={{ cursor: "pointer" }}
                        id={details.id}
                        onClick={() => {
                          setTaskId(details.taskId);
                          setVisibleProc(true);
                        }}
                      >
                        <span
                          className={`dropdown-item ${customStyle(
                            "dropdown-item"
                          )}`}
                        >
                          اضافة إجراء
                        </span>
                      </li>
                      {community?.adminTask && (
                        <li
                          style={{ cursor: "pointer" }}
                          id={details.id}
                          onClick={(e) => {
                            const currentId = e.currentTarget.id;
                            setSubTaskId(currentId);
                            setDeleteModalVisible(true);
                          }}
                        >
                          <span
                            className={`dropdown-item ${customStyle(
                              "dropdown-item"
                            )}`}
                          >
                            حذف الإجراء الفرعي
                          </span>
                        </li>
                      )}
                    </ul>
                  </>
                </div>
              ) : null}

              <Icon
                id={details.id}
                name="ellipsis-v"
                size={18}
                className="icon"
                containerStyle={"icon me-2 align-self-center"}
                onclick={(e) => {
                  const id = e.currentTarget.id;
                  id == null
                    ? setshow({
                        id,
                        display: true,
                      })
                    : id == show.id
                    ? setshow({
                        id: null,
                        display: false,
                      })
                    : setshow({
                        id,
                        display: true,
                      });
                }}
              />
              {/* ellipses end */}
            </div>
          </div>

          {/* date */}
          <div className="d-flex align-items-center px-4">
            <p className="text-muted" style={{ fontSize: 14 }}>
              {Lang.inPeriod}
              <span>
                &nbsp;&nbsp;&nbsp;{Lang.from}{" "}
                {`${moment(new Date(details.startDate)).format("LL")}`}
              </span>{" "}
              <span>
                &nbsp;&nbsp;&nbsp;{Lang.to}{" "}
                {`${moment(new Date(details.endDate)).format("LL")}`}
              </span>
            </p>
          </div>

          {/* popup details */}
          {/* icons */}
          <div className="d-flex flex-wrap align-items-center px-4 mb-3">
            {details?.dayCount?.daystatus ? (
              <div
                className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                  "m",
                  2
                )} mb-2`}
                style={{
                  backgroundColor: "#F2F2F2",
                  width: "fit-content",
                  borderRadius: 10,
                }}
              >
                <div className={`${styleEnd("m", 2)}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16.883"
                    height="18"
                    viewBox="0 0 16.883 18"
                  >
                    <path
                      id="_001-clock"
                      data-name="001-clock"
                      d="M8.442,18.25C.949,18.242-2.821,8.53,2.473,2.871a8.107,8.107,0,0,1,11.938,0C19.7,8.531,15.934,18.242,8.442,18.25Zm0-16.61a7.382,7.382,0,0,0-7.123,7.6c.391,10.084,13.855,10.081,14.245,0A7.382,7.382,0,0,0,8.442,1.64Zm3.071,9.884L9.429,9.3A1.092,1.092,0,0,0,9.1,8.454c0-.007,0-.015,0-.022V4.314a.661.661,0,1,0-1.319,0V8.432c0,.007,0,.015,0,.022A1.066,1.066,0,0,0,8.5,10.3l2.084,2.224a.631.631,0,0,0,.933,0,.738.738,0,0,0,0-1Z"
                      transform="translate(0 -0.25)"
                      fill={details?.dayCount?.color ?? "#3ec4b8"}
                    />
                  </svg>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="my-0">
                    {details?.dayCount?.day >= 0 ? details?.dayCount?.day : ""}
                    &nbsp;
                    {details?.dayCount?.daystatus}
                  </p>
                </div>
              </div>
            ) : (
              <></>
            )}
            {details?.taskStatus?.name ? (
              <div
                className={`d-flex justify-content-center py-2 px-3 mb-2`}
                style={{
                  backgroundColor: "#F2F2F2",
                  width: "fit-content",
                  borderRadius: 10,
                }}
              >
                <div className={`${styleEnd("m", 2)}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <g
                      id="technical-support_1_"
                      data-name="technical-support (1)"
                      transform="translate(0 0.001)"
                    >
                      <path
                        id="Path_428"
                        data-name="Path 428"
                        d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                        transform="translate(0)"
                        fill={details?.taskStatus?.color}
                      />
                      <path
                        id="Path_429"
                        data-name="Path 429"
                        d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                        transform="translate(-190.541 -30.925)"
                        fill={details?.taskStatus?.color}
                      />
                      <path
                        id="Path_430"
                        data-name="Path 430"
                        d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                        transform="translate(-71.384 -71.399)"
                        fill={details?.taskStatus?.color}
                      />
                      <path
                        id="Path_431"
                        data-name="Path 431"
                        d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                        transform="translate(-167.277 -167.277)"
                        fill={details?.taskStatus?.color}
                      />
                      <path
                        id="Path_432"
                        data-name="Path 432"
                        d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                        transform="translate(-326.193 -17.183)"
                        fill={details?.taskStatus?.color}
                      />
                      <path
                        id="Path_433"
                        data-name="Path 433"
                        d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                        transform="translate(-148.933 -457.683)"
                        fill={details?.taskStatus?.color}
                      />
                    </g>
                  </svg>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="my-0">{details?.taskStatus?.name}</p>
                </div>
              </div>
            ) : (
              <></>
            )}
            {details?.procedureCount ? (
              <div
                className="d-flex justify-content-center py-2 me-2 px-3 mb-2 text-decoration-none text-dark"
                style={{
                  backgroundColor: "#F2F2F2",
                  width: "fit-content",
                  borderRadius: 10,
                }}
              >
                <div className=" d-flex">
                  <div
                    className={`d-flex justify-content-center align-items-center ${styleEnd(
                      "m",
                      2
                    )}`}
                    style={{
                      border: "1px solid #1A73E8",
                      backgroundColor: "#1A73E8",
                      color: "white",
                      borderRadius: "50%",
                      width: 24,
                      height: 24,
                      fontSize: 12,
                    }}
                  >
                    {details.procedureCount}
                  </div>
                  <div className="d-flex align-items-center justify-content-center">
                    <p className="my-0">
                      {details.procedureCount > 1
                        ? Lang.procedures
                        : Lang.procedure}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="d-flex flex-column col-11 col-xl-12 mb-5 mt-4">
          <SubTaskDetailsCard
            displayComments={props.displayComments}
            setDisplayComments={props.setDisplayComments}
            procedures={details.procedure}
            commentsUnderProcedure={props.commentsUnderProcedure}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
            subTaskId={details?.id}
          />
        </div>
        {renderTaskAttachmentsModal(taskAttachmentsContent)}
        {renderAttachmentsModal()}
        {/* {renderDetailsModal(details)} */}
      </>
    );
  } else return <div>no details</div>;
};

export default SubTaskDetails;
